import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { NgShuiModule } from '@shui/angular';
import { TableModule } from 'primeng/table';
import { DataService } from 'src/core/services/data.service';
import { SelectedContentService } from 'src/core/services/selectedcontent.service';

type SourceKey = 'autocheck' | 'maintenance' | 'qcIssues' | 'errorEvents';
type SourcePayloadKey = 'autocheck' | 'maintenance' | 'qc' | 'error_events';
type LastUpdatedStatus = 'warning' | 'error' | 'success' | 'confirmation';

interface LastUpdatedRow {
  source: SourceKey;
  status: LastUpdatedStatus;
  lastUpdated: string | null;
  moduleType: string;
}

@Component({
  selector: 'app-instrument-last-updated',
  imports: [TableModule, NgShuiModule, CommonModule, TranslocoModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './instrument-last-updated.component.html',
  styleUrl: './instrument-last-updated.component.css',
})
export class InstrumentLastUpdatedComponent {
  data: any;
  rows: LastUpdatedRow[] = [];
  moduleTypeValid = ['as', 'ci', 'ci 1900 analyzer', 'ci 1900 RH', 'atellica ci analyzer', 'atellica ch 930 analyzer', 'atellica im 1600 analyzer', 'atellica im 1300 analyzer', 'cc', 'ia','direct connect', 'dl','sh additional','sealer','sh connect', 'atellica decapper','sh prime'];
  private readonly sourceMappings: ReadonlyArray<{ source: SourceKey; payloadKey: SourcePayloadKey }> = [
    { source: 'autocheck', payloadKey: 'autocheck' },
    { source: 'maintenance', payloadKey: 'maintenance' },
    { source: 'qcIssues', payloadKey: 'qc' },
    { source: 'errorEvents', payloadKey: 'error_events' },
  ];
  
  constructor(private dataservice: DataService,  private selectedContentService: SelectedContentService) { }

  ngOnInit(): void {
      const serial = this.selectedContentService.currentSystem?.SerialNumber || '';
      const material = this.selectedContentService.currentSystem?.MaterialNumber || '';
      this.dataservice.getSystemHealthLastUpdated(material, serial).subscribe((systemData) => {
        this.data =  systemData.response;
        this.rows = this.mapLastUpdatedRows(this.data);
      });
  }

  private mapLastUpdatedRows(response: any): LastUpdatedRow[] {
    return this.sourceMappings.map(({ source, payloadKey }) => {
        const lastUpdatedRaw = response?.[payloadKey]?.last_updated ?? null;

        return {
          source,
          moduleType: response?.module_type || '',
          status: this.getStatus(lastUpdatedRaw),
          lastUpdated: lastUpdatedRaw
        };
      });
  }

  private getStatus(lastUpdatedRaw: string | null): LastUpdatedStatus {
    if (!lastUpdatedRaw) {
      return 'confirmation';
    }
    const threeDaysInMs = 3 * 24 * 60 * 60 * 1000;
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
    const lastUpdatedMs = new Date(lastUpdatedRaw).getTime();
    const ageInMs = Date.now() - lastUpdatedMs;
    return ageInMs > sevenDaysInMs ? 'error' : ageInMs > threeDaysInMs ? 'warning' : 'success';
  }

 
}
